const SearchUtils = {
  INTERVALS: ['minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'],

  histogramIntervals() {
    return this.INTERVALS;
  },
};

export default SearchUtils;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/util/SearchUtils.js